import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';

import SpecialtyEditModal from '../../../../components/SpecialtyEditModal';
import * as api from '../../../../services/api/admin';

class Specialties extends Component {
  state = {
    isLoading: true,
    specialties: [],
    openEditModal: false,
    specialtyUnderEdit: {},
  };

  async componentDidMount() {
    try {
      this.setState({ isLoading: true });
      await this.fetchSpecialties();
    } catch (err) {
      console.error(err);
      this.props.enqueueSnackbar(
        'Unable to fetch specialties, please refresh the page to try again.'
      );
    } finally {
      this.setState({ isLoading: false });
    }
  }

  fetchSpecialties = async () => {
    const specialties = await api.fetchSpecialties();
    this.setState({ specialties });
  };

  onEdit = specialty => {
    this.setState({ openEditModal: true, specialtyUnderEdit: specialty });
  };

  onNew = () => {
    this.onEdit({});
  };

  onSave = async specialty => {
    const { enqueueSnackbar } = this.props;
    const { specialties } = this.state;
    const isDuplicate = specialties.some(
      item =>
        item.id !== specialty.id && ( // ignore the same specialty
          item.name.toLowerCase().trim() === specialty.name.toLowerCase().trim() ||
          item.shortName.toLowerCase().trim() === specialty.shortName.toLowerCase().trim()
        )
    );
    if(isDuplicate){
      enqueueSnackbar('Specialty already exist.');
      return;
    }
    try {
      if (specialty.id) {
        await api.updateSpecialty(specialty);
      } else {
        await api.createSpecialty(specialty);
      }
      enqueueSnackbar('Specialty updated!');
      this.onClose();
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to save specialty, please try again.');
    } finally {
      this.fetchSpecialties();
    }
  };

  onClose = () => {
    this.setState({ openEditModal: false, specialtyUnderEdit: {} });
  };

  render() {
    const { classes } = this.props;
    const { isLoading, specialties, openEditModal, specialtyUnderEdit } = this.state;

    if (isLoading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Short Name</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {specialties.map(specialty => (
              <TableRow key={specialty.id}>
                <TableCell width="300">{specialty.name}</TableCell>
                <TableCell width="300">{specialty.shortName}</TableCell>
                <TableCell>
                  <IconButton onClick={() => this.onEdit(specialty)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Grid
          container
          justifyContent="flex-end"
          classes={{ container: classes.actions }}
        >
          <Grid item xs={12} md={4} lg={2}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={this.onNew}
            >
              + Add Specialty
            </Button>
          </Grid>
        </Grid>

        {openEditModal && (
          <SpecialtyEditModal
            specialty={specialtyUnderEdit}
            open={openEditModal}
            save={this.onSave}
            onClose={this.onClose}
          />
        )}
      </>
    );
  }
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actions: {
    marginTop: '2em',
  },
});

export default withSnackbar(withStyles(styles)(Specialties));
